module.exports = __webpack_public_path__ + "static/media/learning management system.a448eab8.svg";